import { Settings } from '../reducer';

const migrateKeys = (settings: Settings, oldSettingsVersion: number) => {
    if (oldSettingsVersion < 1) {
        const driverAnalysisSortBy = settings.driverAnalysisSortBy;
        if (
            driverAnalysisSortBy &&
            typeof driverAnalysisSortBy === 'object' &&
            driverAnalysisSortBy !== null &&
            'key' in driverAnalysisSortBy &&
            (driverAnalysisSortBy as any).key === 'vehicle'
        ) {
            (driverAnalysisSortBy as any).key = 'vehicles';
        }

        const driverAnalysisColumnOrder = settings.driverAnalysisColumnOrder;
        if (
            driverAnalysisColumnOrder &&
            typeof driverAnalysisColumnOrder === 'object' &&
            driverAnalysisColumnOrder !== null
        ) {
            Object.keys(driverAnalysisColumnOrder).forEach(function(useCaseKey) {
                const useCaseColumnOrder = (driverAnalysisColumnOrder as any)[useCaseKey];
                if (Array.isArray(useCaseColumnOrder)) {
                    const idx = useCaseColumnOrder.indexOf('vehicle');
                    if (idx >= 0) {
                        useCaseColumnOrder[idx] = 'vehicles';
                    }
                }
            });
        }
    }

    return settings;
};

export default migrateKeys;
